import { BaseApiService } from "./BaseApiService";
import { ImageBrowserModel } from "../models/images/ImageBrowserModel";

export class ImagesService extends BaseApiService {
    static getImages(): Promise<ImageBrowserModel> {
        return this.get<ImageBrowserModel>("/images");
    }
}
